/* Portada · Sorpréndeme y Carta al azar: piezas reales y disponibles del catálogo.
   /products.json (público) con una página aleatoria de 1 producto; si la pieza está vendida, se intenta otra. */
(function () {
  /* Lo cargan Sorpréndeme y Recién llegadas; si están las dos en la misma página, corre una sola vez */
  if (window.MoonsPortada) return;
  window.MoonsPortada = true;

  /* Fuente: la colección «disponibles» (solo piezas con existencia) si la sección la declara; si no, todo el catálogo */
  var fuenteEl = document.querySelector('[data-fuente]');
  var fuente = (fuenteEl && fuenteEl.dataset.fuente) || '/products.json';
  function piezaAlAzar(total) {
    var intentos = 0;
    function intenta() {
      intentos++;
      var pagina = 1 + Math.floor(Math.random() * Math.min(total, 5000));
      return fetch(fuente + '?limit=1&page=' + pagina, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var p = d && d.products && d.products[0];
          /* Un accesorio (GradedGuard) no es una sorpresa de cartas: se salta como si no estuviera (20 oct 2026) */
          var disponible = p && p.product_type !== 'Accesorio' && p.product_type !== 'Sellado' && p.variants && p.variants.some(function (v) { return v.available; });
          if (disponible) return p;
          if (intentos < 5) return intenta();
          return null;
        });
    }
    return intenta();
  }

  // Sorpréndeme: vuelve a pintar la sección en contexto del producto elegido
  var sorpresa = document.querySelector('[data-sorpresa]');
  if (sorpresa) {
    sorpresa.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-sorpresa-otra]');
      if (!boton || sorpresa.getAttribute('aria-busy') === 'true') return;
      var total = parseInt(sorpresa.dataset.total, 10) || 0;
      if (!total) return;
      sorpresa.setAttribute('aria-busy', 'true');
      piezaAlAzar(total)
        .then(function (p) {
          if (!p) throw new Error('sin pieza');
          return fetch('/products/' + p.handle + '?section_id=sorprendeme', { headers: { Accept: 'text/html' } });
        })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevo = doc.querySelector('[data-sorpresa]');
          if (!nuevo) throw new Error('sin sección');
          sorpresa.innerHTML = nuevo.innerHTML;
          var titulo = sorpresa.querySelector('#sorpresa-titulo');
          if (titulo) titulo.focus({ preventScroll: true });
        })
        .catch(function () {})
        .then(function () { sorpresa.removeAttribute('aria-busy'); });
    });
  }

  // Carta al azar (enlace): navega a la ficha de una pieza disponible
  document.querySelectorAll('[data-carta-al-azar]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var total = parseInt(a.dataset.total, 10) || 0;
      var destino = a.getAttribute('href');
      if (!total) {
        window.location.href = destino;
        return;
      }
      a.setAttribute('aria-busy', 'true');
      piezaAlAzar(total)
        .then(function (p) { window.location.href = p ? '/products/' + p.handle : destino; })
        .catch(function () { window.location.href = destino; });
    });
  });
})();
